import { render, staticRenderFns } from "./resources.vue?vue&type=template&id=f8a28e28&scoped=true"
import script from "./resources.vue?vue&type=script&lang=js"
export * from "./resources.vue?vue&type=script&lang=js"
import style0 from "./resources.vue?vue&type=style&index=0&id=f8a28e28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8a28e28",
  null
  
)

export default component.exports